import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, onBeforeMount } from "vue";
import { followCarList, followCarTypeList, depositTypeMap, settleTypeMap, freightUnitTypeMap, invoiceTypes, insuranceMap } from "../../util/type";
export default {
  name: "shipmentsdetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      viewNum: 0,
      demandId: 0,
      tabsIndex: 0,
      comps: [{
        label: "基本信息",
        name: "GoodsBasicInfo"
      }, {
        label: "关联订单",
        name: "AssociatedOrder"
      }]
    });
    onBeforeMount(() => {
      data.demandId = route.query.demandId;
      if (route.query.onlyViewBasicInfo == 1) {
        data.comps.pop();
      }
    });
    onMounted(() => {});
    const changeTabs = index => {
      data.tabsIndex = index;
    };
    return {
      data,
      changeTabs
    };
  }
};